import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
//const Progress = React.lazy(() => import('./components/Progress'));
//import * as microsoftTeams from '@microsoft/teams-js'
import { app } from '@microsoft/teams-js';
import * as Sentry from '@sentry/browser';
import 'draft-js/dist/Draft.css';
import './styles.less';
import SuspanseFallbackPage from './pages/SuspanseFallbackPage';
import { checkError } from './helpers/filterErrorHelperClient';
import { ensureOfficeSdkLoaded, shouldLoadOfficeSdk } from './helpers/officeSdkLoader';
import { PersonaContextProvider } from './context/PersonaContextProvider';
import './i18n';
import { MeetingContextProvider } from './context/MeetingContextProvider';
import { ReviewContextProvider } from './context/ReviewContextProvider';
import { TeamContextProvider } from './context/TeamContextProvider';
import { TenantStoreProvider } from './context/TenantStoreContext';
import { injectTokens } from '@ui';
//import App from './App';
var App = /*#__PURE__*/ React.lazy(function() {
    return import('./App');
});
// Emits the `--tf-*` design tokens both `semantic` and the TF `.less` files reference.
// Must run before the first render, or those `var()`s resolve to nothing for a frame.
injectTokens();
// Teamflect CDN causes random CORS errors when loading font files
// initializeIcons('https://teamflectcdn.teamflect.com/teamflect/fabric-icons/')
initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/');
app.initialize().catch(function() {});
if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://f0ecba485a5146cc9684969874b7aa34@sentry.io/1814786',
        beforeSend: function beforeSend(event, hint) {
            var error = hint.originalException;
            return checkError(error, event);
        },
        environment: process.env.ENVIRONMENT === 'prod' ? 'production' : process.env.ENVIRONMENT,
        ignoreErrors: [
            'Non-Error promise rejection captured',
            'Non-Error exception captured',
            'ResizeObserver loop completed with undelivered notifications' // Common error
        ]
    });
}
var root = ReactDOM.createRoot(document.getElementById('container') || document.createElement('div')) // second parameter added for test purposes!!);
;
function boot() {
    return _async_to_generator(function() {
        var e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!shouldLoadOfficeSdk()) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        ensureOfficeSdkLoaded()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    // Fail-open: render anyway. Login keeps its own retry/error UI; mailbox
                    // components degrade as they would today if Office were absent.
                    Sentry.captureException(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    root.render(/*#__PURE__*/ _jsx(PersonaContextProvider, {
                        children: /*#__PURE__*/ _jsx(MeetingContextProvider, {
                            children: /*#__PURE__*/ _jsx(ReviewContextProvider, {
                                children: /*#__PURE__*/ _jsx(TeamContextProvider, {
                                    children: /*#__PURE__*/ _jsx(TenantStoreProvider, {
                                        children: /*#__PURE__*/ _jsx(React.Suspense, {
                                            fallback: /*#__PURE__*/ _jsx(SuspanseFallbackPage, {}),
                                            children: /*#__PURE__*/ _jsx(App, {})
                                        })
                                    })
                                })
                            })
                        })
                    }));
                    return [
                        2
                    ];
            }
        });
    })();
}
boot();
